!function(){
  const config = JSON.parse(document.querySelector("[data-store-locator-options]").getAttribute("data-store-locator-options"));
  
  if(mapboxgl.accessToken = atob(config.accessToken), "nohdt" == mapboxgl.accessToken) return;
  
  // Obtener la URL del archivo JSON externo
  const dataUrlConfig = document.getElementById(`stores-data-url${config.sid}`);
  const externalDataUrl = dataUrlConfig ? JSON.parse(dataUrlConfig.textContent).dataUrl : null;
  
  // Función para inicializar el mapa con los datos
  function initializeMap(storesData) {
    const map = new mapboxgl.Map({
      container: `map${config.sid}`,
      style: {
        streets: "mapbox://styles/mapbox/streets-v12",
        outdoors: "mapbox://styles/mapbox/outdoors-v12",
        light: "mapbox://styles/mapbox/light-v11",
        dark: "mapbox://styles/mapbox/dark-v11",
        satellite_streets: "mapbox://styles/mapbox/satellite-streets-v12"
      }[config.style],
      center: storesData.features[0].geometry.coordinates,
      zoom: config.zoom,
      scrollZoom: config.scrollZoom,
      attributionControl: !1,
      pitch: config.pitch,
      bearing: config.bearing
    });
    
    map.addControl(new mapboxgl.NavigationControl);
    
    if(config.enableSearchBox) {
      const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        marker: !0,
        render: function(result) {
          var parts = result.place_name.split(",");
          return '<div class="mapboxgl-ctrl-geocoder--suggestion"><div class="mapboxgl-ctrl-geocoder--suggestion-title needsclick">' + parts[0] + '</div><div class="mapboxgl-ctrl-geocoder--suggestion-address needsclick">' + parts.splice(1, parts.length).join(",") + "</div></div>"
        }
      });
      map.addControl(geocoder, "top-left")
    }
    
    storesData.features.forEach((feature, index) => {
      feature.properties.id = index
    });
    
    map.on("idle", () => {
      map.setFog({}), map.resize()
    });
    
    map.on("load", () => {
      map.addSource("places", {
        type: "geojson",
        data: storesData
      });
      
      buildLocationList(storesData);
      addMarkers(storesData, map);
    });
    
    const isImgMarker = config.isImgMarker;
    
    function flyToStore(currentFeature) {
      map.flyTo({
        center: currentFeature.geometry.coordinates,
        zoom: 15
      })
    }
    
    function createPopUp(currentFeature) {
      const popUps = document.getElementsByClassName("mapboxgl-popup");
      popUps[0] && popUps[0].remove();
      
      const {name, content} = currentFeature.properties;
      const popup = new mapboxgl.Popup({closeOnClick: !1})
        .setLngLat(currentFeature.geometry.coordinates)
        .setHTML(`<h3>${name}</h3>${content}`)
        .addTo(map);
      
      popup._container.querySelector(".mapboxgl-popup-content p").classList.add("hdt-rte");
      
      if(window.width < 768) {
        setTimeout(() => {
          popup._container.scrollIntoView({block: "end", behavior: "smooth"})
        }, 100)
      }
    }
    
    function buildLocationList(data) {
      const listings = document.getElementById(`listings${config.sid}`);
      listings.innerHTML = "";
      
      for(const feature of data.features) {
        const listing = listings.appendChild(document.createElement("div"));
        const {name, content} = feature.properties;
        
        listing.id = `hdt-listing-${feature.properties.id}`;
        listing.className = "hdt-store-locator__item";
        
        const link = listing.appendChild(document.createElement("a"));
        link.href = "#";
        link.className = "hdt-store-locator__title needsclick";
        link.id = `hdt-link-${feature.properties.id}`;
        link.innerHTML = `${name}`;
        
        const details = listing.appendChild(document.createElement("div"));
        details.className = "hdt-rte";
        details.innerHTML = content;
        
        listing.addEventListener("click", function(e) {
          e.preventDefault();
          for(const item of data.features) {
            if(this.id === `hdt-listing-${item.properties.id}`) {
              flyToStore(item);
              createPopUp(item);
            }
          }
          const activeItem = listings.getElementsByClassName("is--active");
          activeItem[0] && activeItem[0].classList.remove("is--active");
          this.classList.add("is--active")
        })
      }
    }
    
    function addMarkers(data, map) {
      for(const feature of data.features) {
        const el = document.createElement("div");
        el.id = `hdt-marker-${feature.properties.id}`;
        el.className = "hdt-store-locator__marker";
        
        if(!isImgMarker) {
          el.innerHTML = '<svg class="hdt-icon hdt-icon--store-locator" aria-hidden="true" focusable="false" role="presentation"><use href="#icon--store-locator-marker"></use></svg>';
        }
        
        new mapboxgl.Marker(el, {offset: [0, -23]})
          .setLngLat(feature.geometry.coordinates)
          .addTo(map);
        
        el.addEventListener("click", event => {
          flyToStore(feature);
          createPopUp(feature);
          
          const activeItem = document.getElementsByClassName("is--active");
          event.stopPropagation();
          activeItem[0] && activeItem[0].classList.remove("is--active");
          
          const listing = document.getElementById(`hdt-listing-${feature.properties.id}`);
          listing.classList.add("is--active")
        })
      }
    }
  }
  
  // Cargar datos desde archivo externo o desde el script inline
  if(externalDataUrl) {
    fetch(externalDataUrl)
      .then(response => response.json())
      .then(data => {
        // Convertir el formato del JSON a GeoJSON
        const geoJsonData = {
          type: "FeatureCollection",
          features: data.stores.map(store => ({
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [parseFloat(store.longitude), parseFloat(store.latitude)]
            },
            properties: {
              name: store.heading,
              content: store.content
            }
          }))
        };
        initializeMap(geoJsonData);
      })
      .catch(error => {
        console.error('Error loading store locations:', error);
        // Fallback a datos inline si existen
        const inlineData = JSON.parse(document.getElementById(`stores-json${config.sid}`).textContent);
        if(inlineData.features.length > 0) {
          initializeMap(inlineData);
        }
      });
  } else {
    // Usar datos inline
    const inlineData = JSON.parse(document.getElementById(`stores-json${config.sid}`).textContent);
    initializeMap(inlineData);
  }
  
  // Manejo de recarga de sección en el editor
  document.addEventListener("shopify:section:load", event => {
    if(![...event.target.classList].includes("hdt-main-store-locator")) return;
    const scriptTag = document.querySelector("[id^=hdt-store-locator-js]");
    if(scriptTag) {
      const newScript = document.createElement("script");
      newScript.src = scriptTag.src;
      scriptTag.parentNode.replaceChild(newScript, scriptTag);
    }
  });
}();
